import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const AdminContent = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./content')).AdminContent })
  )
)

export const AdminNotificationIcon = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./experiments')).NotificationIcon })
  )
)
